import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/vercel/path0/node_modules/.pnpm/next-auth@5.0.0-beta.25_next@15.5.9_@babel+core@7.26.9_@opentelemetry+api@1.9.0_react-dom@18._h2u4nmj5vns4v4wjdltrs74uzy/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/src/app/posthog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AIResponseModal"] */ "/vercel/path0/src/components/ai-assistant/AIResponseModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AIResponseModalProvider"] */ "/vercel/path0/src/contexts/AIResponseModalContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/vercel/path0/src/trpc/react.tsx");
